import { IconSync } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

import { Application } from '../../Dashboard.types';
import styles from '../SpendingLimitDrawer.module.css';
import { UnavailableLimit } from './UnavailableLimit';
import { daysSinceStatusDate } from '../../Dashboard.helpers';
import {
    TSpendingLimits,
    TSpendingLimitType
} from '../../hooks/useGetSpendingLimits';

export const DeclinedLimitDrawer = ({
    spendingLimits,
    refreshSpendingLimit,
    loadingRefreshSpendingLimit,
    isError,
    application
}: {
    spendingLimits: TSpendingLimits;
    refreshSpendingLimit: () => Promise<void>;
    loadingRefreshSpendingLimit: boolean;
    isError: boolean;
    application: Application;
}) => {
    const daysSinceDecline = daysSinceStatusDate(application);

    // Don't let them refresh until 30 days after decline.
    // If we don't know how many days since decline, let them try
    const showRefreshButton =
        daysSinceDecline !== null ? daysSinceDecline >= 30 : true;

    return (
        <>
            <div className={styles.spendingLimits}>
                {Object.keys(spendingLimits.limits)
                    .filter((spendingLimitKey) => {
                        // Exclude THIRTY_DAYS limit
                        // Same limit as three months
                        return spendingLimitKey !== 'THIRTY_DAYS';
                    })
                    .map((key) => {
                        return (
                            <UnavailableLimit
                                sellerProduct={key as TSpendingLimitType}
                                key={key}
                            />
                        );
                    })}
                {showRefreshButton && (
                    <div>
                        <Button
                            disabled={loadingRefreshSpendingLimit}
                            onClick={refreshSpendingLimit}
                            className={styles.refreshButton}
                        >
                            {loadingRefreshSpendingLimit ? (
                                <>
                                    <IconSync className={styles.spinningIcon} />
                                    Checking limits...
                                </>
                            ) : (
                                <>
                                    <IconSync />
                                    Secure my limits
                                </>
                            )}
                        </Button>
                        {isError && (
                            <div className={styles.errorMessage}>
                                Something went wrong
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};
